export const DATE_FIELDS = ['birthday', 'earliestPossibleJoinDate'] as const;

// Das Formular liefert TT.MM.JJJJ (auch 1.11.2026), API und DateField erwarten JJJJ-MM-TT.
// Zweistellige Jahre und unvollstaendige Eingaben sind kein Datum; die API lehnte "26-11-01" ab.
export const toIsoDate = (value: string): string | undefined => {
  const trimmed = value.trim();
  const masked = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(trimmed);
  if (masked) return `${masked[3]}-${masked[2].padStart(2, '0')}-${masked[1].padStart(2, '0')}`;

  return /^\d{4}-\d{2}-\d{2}$/.test(trimmed) ? trimmed : undefined;
};

// Fuer die Validierung: Lesbares wird ISO, Unlesbares bleibt stehen und faellt im Schema durch.
export const withIsoDates = <T extends Record<string, unknown>>(values: T): T => {
  const result = { ...values };
  for (const key of DATE_FIELDS) {
    const value = result[key];
    if (typeof value === 'string' && value.trim()) {
      (result as Record<string, unknown>)[key] = toIsoDate(value) ?? value;
    }
  }

  return result;
};

// Fuer die Wiederbefuellung nach einem Fehler: Das DateField macht aus einem Nicht-ISO-Wert
// "undefined.undefined.04.02.1997", deshalb bleibt ein unlesbares Datum leer.
export const extractFormInputs = (formData: FormData): Record<string, string | undefined> => {
  const inputs: Record<string, string | undefined> = {};
  for (const [key, value] of formData.entries()) {
    if (typeof value === 'string') {
      inputs[key] = value || undefined;
    }
  }
  for (const key of DATE_FIELDS) {
    const value = inputs[key];
    if (value !== undefined) inputs[key] = toIsoDate(value);
  }

  return inputs;
};
